import React, {useEffect, useState} from "react";

import applicablePolicyTableDataSource from "__mocks__/applicablePolicyTable";
import {Checkbox, Popconfirm, Row, Table, message, notification} from "antd";
import {ColumnsType} from "antd/es/table";
import useFetch from "hooks/useFetch";
import {medicalExaminationService} from "api";
import {useAppSelector} from "redux/hooks";
import {STATUS_CARD, STATUS_DISCOUNT} from "assets/constants/card-types";
import {setReloadListCard} from "redux/reducer/receive";
import {useDispatch} from "react-redux";
import {formatDateToString} from "helper/common";
import {FORMAT_TIME} from "types/enums";

const ListPolicy = props => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setErr] = useState<any>();

  const fetchData = async (params?: any) => {
    try {
      setLoading(true);
      let response =
        await medicalExaminationService.getDonBanTheKhamByIdBenhNhan({
          idBenhNhan: dataPassing.idBenhNhan,
        });
      setData(response);
      setLoading(false);
    } catch (error) {
      // notification.error({message: "Lỗi khi lấy danh sách chính sách"});
      setLoading(false);
    }
  };

  const dataPassing = useAppSelector(state => state.receive.dataPassing);
  const receive = useAppSelector(state => state.receive);
  useEffect(() => {
    if (data && dataPassing?.idBenhNhan) {
      fetchData();
    } else {
      setData([]);
    }
  }, [dataPassing]);
  useEffect(() => {
    if (receive.reloadListCard) {
      fetchData();
      dispatch(setReloadListCard(false));
    }
  }, [receive]);

  const columns: ColumnsType = [
    {
      title: "STT",
      key: "stt",
      dataIndex: "stt",
      align: "center",
      render: (_v, _r, idx) => <>{idx + 1}</>,
    },
    {
      title: "Mã loại thẻ/Mã KM",
      key: "ma",
      dataIndex: "ma",
      align: "left",
    },
    {
      title: "Tên loại thẻ",
      key: "ten",
      dataIndex: "tenLoaiThe",
      align: "left",
    },
    {
      title: "Ngày phát hành",
      key: "createdDate",
      dataIndex: "createdDate",
      align: "center",
      render(value, record, index) {
        return <div>{formatDateToString(value, FORMAT_TIME.dayFull)}</div>;
      },
    },
    {
      title: "Trạng thái",
      key: "trangThai",
      dataIndex: "trangThai",
      align: "left",
      render: (v, r: any, i) => {
        if (r.loai === 0) {
          return STATUS_CARD.find(it => it.value === v)?.label || "";
        } else return STATUS_DISCOUNT.find(it => it.value === v)?.label || "";
      },
    },
    {
      title: "Số lượng đã mua",
      key: "soLuong",
      dataIndex: "soLuong",
      align: "right",
    },
  ];

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Row>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        bordered
      />
    </Row>
  );
};

export default ListPolicy;
